export default () => {
    window.jQuery('input[data-toggle-on-change-url]').each((index, input) => {
        const url = input.getAttribute("data-toggle-on-change-url");
        $(input).on('change', async (ev) => {
            await window.axios.post(url);
            window.location.reload();
        });
    });
}
